import { render } from "./EventViewSurvey.vue?vue&type=template&id=0e9d970c&lang=pug"
import script from "./EventViewSurvey.vue?vue&type=script&lang=js"
export * from "./EventViewSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__